import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { userApi, formatApiErrorDetail } from "../../lib/api";
import Seo from "../../components/Seo";
import { toast } from "sonner";

const inp = "w-full px-4 py-3 text-sm rounded-sm border border-brand-gold-light/50 bg-white outline-none focus:border-brand-gold";

export default function ResetPassword() {
  const [sp] = useSearchParams(); const token = sp.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState(""); const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    try { await userApi.post("/auth/reset-password", { token, password }); toast.success("Şifren güncellendi."); nav("/giris"); }
    catch (er) { setErr(formatApiErrorDetail(er.response?.data?.detail)); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-6 py-28">
      <Seo title="Şifre Sıfırla" />
      <div className="w-full max-w-md bg-brand-offwhite border border-brand-gold-light/40 rounded-sm p-10">
        <h1 className="font-serif text-3xl text-brand-green text-center mb-6">Yeni Şifre Belirle</h1>
        <form onSubmit={submit} data-testid="reset-form" className="space-y-4">
          <input required type="password" placeholder="Yeni şifre (en az 6 karakter)" value={password} onChange={(e) => setPassword(e.target.value)} className={inp} data-testid="reset-password" />
          {err && <p className="text-red-700 text-sm">{err}</p>}
          <button data-testid="reset-submit" className="w-full bg-brand-gold text-brand-offwhite hover:bg-brand-green transition-colors py-3 rounded-sm font-semibold">Şifreyi Güncelle</button>
        </form>
        <p className="text-center mt-5 text-sm"><Link to="/giris" className="text-brand-gold">Girişe dön</Link></p>
      </div>
    </div>
  );
}
